/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Stack } from '@mybridge/ui/layout';
import React, { useEffect, useState, useContext } from 'react';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { TeamsContext } from '../teams/context';
import _ from 'lodash';
import { getSelectedRoomMembers } from 'v4/store/actions/global.data.actions';
import { ChatDownArrowIcon } from '@mybridge/icons/ChatDownArrowIcon';
import {
  MemberIcon,
  CalendarChatIcon,
  EditPostIcon,
  MeetNow,
  InviteFriends,
  BlockMemberIcon,
  ExitGroup,
  ReportIcon,
} from '@mybridge/icons';
import styles from './statusProfile.module.scss';
import { border, VStack } from '@chakra-ui/react';
import { Text } from '@mybridge/ui';
import Link from 'next/link';
import { MyNetworkContext } from 'v4/components/network/context';
import { useSelector } from 'react-redux';
import BlockedUserPopup from './block-user-popup';
import { useRouter } from 'next/router';
import { useDispatch} from 'react-redux';
import {
  joinMeeting,
  generateMeetingId,
  scheduleMeetingWithUser,
} from 'v4/store/actions/meeting.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { UserProfileIcon } from '@mybridge/icons/chat-icons';
const MessagePopOver = ({
  setIsBlockUserModal,
  selectedChat,
  isBlockUserModal,
  onclick,
  setIsGroupModalOpen,
  isCreateGroupedClicked,
  setIsCreateGroupedClicked,
  groupMemberDetail,
  onSendMessage,
  teamDetails,
  roomId,
  ...props
}) => {
  const chatState = useSelector((state) => state.chat);
  const router = useRouter();
  const { t } = useTranslator();
  const createGroupText = `${t('myMessages.createGroupWith') || "Create group with"} ${selectedChat?.user_details?.display_name}`;
  const { setSelectedUser, reportUserDisc } = useContext(MyNetworkContext);
  const { userProfileInfo } = useSelector((state) => state?.userProfile);
  const dispatch = useDispatch();
  const selectedUser = groupMemberDetail?.find((item) => item?.id !== userProfileInfo?.id);
  const currentUserId = userProfileInfo?.id; // Assuming `userProfileInfo` has the current user's ID
  const { matrixClient, loggedInUser, teamsChats, callStatus,initiateMatrixCall } = useContext(MatrixContext);
  const { setChatTeamSlug, chatTeamSlug, isOrganizer, chatRoom, teamMembers, setChatRoom, leaveTeamDisc } = useContext(TeamsContext);

        // useEffect(() => {
        //   if (roomId) {
        //     dispatch(getSelectedRoomMembers(roomId)).then((res) => {
        //       // console.log("Room members fetched:", res?.payload?.members);
        //     });
        //   }
        // }, [roomId, dispatch]);
      
  const handleStartTeamMeeting = async () => {;
      await dispatch(generateMeetingId()).then(async(res) => {
        if (res) {
          const meetingId = res.payload.meeting_id;
          const meetingLink = `${process.env.BASE_PUBLIC_URL}meet/${meetingId}`;
  
          const plainTextMessage = `Let's meet\nPlease join using this link: ${meetingLink} \n Meeting ID: ${meetingId}`;
          const htmlMessage = `
            Let's meet<br/>
            Please join using this link: 
            <a href="${meetingLink}">${meetingLink}</a><br/>
            Meeting ID: ${meetingId}
          `;
  
          const content = {
            body: plainTextMessage, 
            type: 'org.matrix.custom.html', 
            formatted_body: htmlMessage,  
            msg_type: 'm.text',  
          };
  
          if (onSendMessage) {
           await onSendMessage(content)
            dispatch(
                      joinMeeting({
                        created_by: userProfileInfo,
                        meetingId: res.payload.meeting_id,
                        attendees: null,
                        isWaiting: true,
                      })
                    );
          }
        }
      });
    }
    


    const handleScheduleMeeting = () => {
      dispatch(
        scheduleMeetingWithUser({
          users: _.map(groupMemberDetail, 'user'),
          type: 'chat',
        })
      );
      router.push(`/profile/calendar/schedule?room=${selectedChat?.room_id}`);
    };

  return (
   
    <Box>
      <Popover placement="bottom-end" isLazy>
      {({ onClose }) => (
      <>
        <PopoverTrigger>
          <button>
            <ChatDownArrowIcon />
          </button>
        </PopoverTrigger>
        <PopoverContent
          marginTop={'0px'}
          padding={'16px'}
          mr={'-50px'}
          backgroundColor="#F9F9F9"
          borderRadius={'16px'}
          className={styles.statusDropdown}
        >
          <PopoverBody
            py={0}
            px={'0px'}
            style={{ outline: 'none', borderRadius: '12px' }}
            
          >
            <VStack alignItems="start" gap={'16px'}>
              <HStack  alignItems="center" cursor="pointer" gap="10px" 
                     sx={{
                    ':hover': {
                      borderRadius:"50px",
                      backgroundColor: '#EDEDED',
                      width: '100%',
                      cursor: 'pointer',
                    
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                
                    },
                  }}
               onClick={() => {
                handleStartTeamMeeting();
                onClose(); 
              }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MeetNow width="16" height="16" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {' '}
                  {t('profileNetwork.meetNow') || "Meet now"}
                </Text>
              </HStack>
              <HStack sx={{
                    ':hover': {
                      width: '100%',
                      borderRadius:"50px",
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                    
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    },
                  }}
                cursor="pointer"
                // as={Link}
                // href={'/profile/calendar/schedule'}
                onClick={handleScheduleMeeting}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <CalendarChatIcon color="#5B5B5B" width="18" height="18" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('common.scheduleMeeting') || "Schedule a Meeting"}
                </Text>
              </HStack>

              <HStack
              sx={{
                    ':hover': {
                      width: '100%',
                      borderRadius:"50px",
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                    
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                     
                    },
                  }}
                cursor="pointer"
                onClick={() => {
                  setIsGroupModalOpen({ open: true, data: 'create' });
                  setIsCreateGroupedClicked(true);

                }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MemberIcon />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {createGroupText}
                </Text>
              </HStack>
              <HStack
              sx={{
                    ':hover': {
                      width: '100%',
                      borderRadius:"50px",
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                    
                    },
                  }}
                cursor="pointer"
                onClick={() => {
                  setIsBlockUserModal();
                }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <BlockMemberIcon width="18" height="18" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('profileNetwork.block') || "Block"}
                </Text>
              </HStack>
              {/* <HStack
                cursor="pointer"
                onClick={() => {
                  setBlockedMemberPopup(true);
                }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <BlockMemberIcon width="18" height="18" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  Blocked Member
                </Text>
              </HStack> */}
              <HStack
              sx={{
                    ':hover': {
                      width: '100%',
                      borderRadius:"50px",
                      backgroundColor: '#EDEDED',
                      cursor: 'pointer',
                      fontWeight: '400',
                      boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                     
                    },
                  }}
                cursor="pointer"
                onClick={() => {
                  setSelectedUser(selectedUser)
                  reportUserDisc?.onOpen?.();
                }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <ReportIcon width="18" height="15" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('profilePhotosVideos.report') || "Report"}
                </Text>
              </HStack>

              <HStack
                sx={{
                  ':hover': {
                    width: '100%',
                    borderRadius:"50px",
                    backgroundColor: '#EDEDED',
                    cursor: 'pointer',
                    fontWeight: '400',
                    boxShadow: '0px 14px 44px 0px rgba(0, 0, 0, 0.04)',
                  },
                }}
                cursor="pointer"
                onClick={() => {
                  router.push(`/p/${selectedUser?.slug}`);
                  
                }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <UserProfileIcon width="18" height="15" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('publicProfile.profile') || "Profile"}
                </Text>
              </HStack>
            </VStack>
          </PopoverBody>
        </PopoverContent>
        </>
      )}
      </Popover>
    </Box>
  );
};

export default MessagePopOver;
